import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { CommonErrorCode, UserErrorCode } from '~commonInfra/utils/ErrorCodes';

import { Messages } from '../../../codegen/Localize';
import { L10n } from '../../../commonInfra/L10n/L10n';
import { IError } from '../../../httpClient/serverApi/types/IError';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { SiteRoleOptionsResource } from '../resources/SiteRoleOptions';

// Notification For:
// => adding users to site

export class AddUserToSiteActionNotification {

  public static readonly instance = new AddUserToSiteActionNotification();

  public notify(
    showErrorMsgFunc: (errorMsg: string) => void,
    result: IResult,
    username: string,
    siteRoleEnum: string) {

    if (!!result.errors && result.errors.length > 0) {
      const errorMsg: string = this.errorMessageFor(result.errors[0], username);
      showErrorMsgFunc(errorMsg);
    } else {
      let siteRoleOptions: SiteRoleOptionsResource = SiteRoleOptionsResource.instance;
      const translatedSiteRole: string = siteRoleOptions.getSiteRoleName(siteRoleEnum)();
      const successMsg = Messages.addUserToSiteWithSiteRoleSuccessMsg({ NEW_ITEM_NAME: L10n.elideIfLong(username), SITE_ROLE: translatedSiteRole });
      ToasterService.instance.pop({ type: ToastType.Info, text: successMsg });
    }
  }

  private errorMessageFor(error: IError, username: string) {
    switch (error.code) {
      case CommonErrorCode.SystemUserNotFound:
        return Messages.errorSystemUserNotFound({ USER_NAME: L10n.elideIfLong(username) });
      case UserErrorCode.UserAlreadyExists:
        return Messages.errorUserAlreadyExists({ NEW_ITEM_NAME: L10n.elideIfLong(username) });
      case UserErrorCode.UserInsufficientSiteQuota:
        return Messages.errorUserInsufficientSiteQuota();
      case UserErrorCode.UserInvalidAuthenticationSetting:
        return Messages.errorUserCannotHaveTableauAuthType({ USER_NAME: L10n.elideIfLong(username) });
      default:
        return Messages.errorUnknown();
    }
  }
}

export default AddUserToSiteActionNotification.instance;
